import { render, staticRenderFns } from "./topbarGoEvalsList.vue?vue&type=template&id=8098facc&"
import script from "./topbarGoEvalsList.vue?vue&type=script&lang=js&"
export * from "./topbarGoEvalsList.vue?vue&type=script&lang=js&"
import style0 from "./topbarGoEvalsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports